import { render, staticRenderFns } from "./ProductivityReportTable.vue?vue&type=template&id=00b2973c"
import script from "./ProductivityReportTable.vue?vue&type=script&lang=js"
export * from "./ProductivityReportTable.vue?vue&type=script&lang=js"
import style0 from "./ProductivityReportTable.vue?vue&type=style&index=0&id=00b2973c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports